/**
 * Original Author: Aaron Turnblom
 * Original Team: Area 51
 */
export default {
  props: {
    locale: {
      type: String,
      default: 'en_US',
    },
  },
  computed: {
    parsedLocale() {
      const value = /([A-Z]{2})_([A-Z]{2})/i.exec(this.locale);
      if (value) {
        return {
          language: value[1],
          country: value[2],
        };
      }
      return {
        language: null,
        country: null,
      };
    },
    localeLanguage() {
      return this.parsedLocale.language;
    },
    localeCountry() {
      return this.parsedLocale.country;
    },
  },
};
